<script>
import _ from 'lodash';
export default {
  name: 'lego-tree',
  emits: ['addButton', 'deleteButton', 'selectNode', 'editButton'],
  props: {
    defaultSelectedKey: {
      type: String,
      default: undefined
    }
  },
  watch: {
    value(val, preVal) {
      if (preVal.length === 0) {
        this.scanTreeNode(val);
      }
    },
    defaultSelectedKey() {
      this.scanTreeNode(this.value);
    }
  },
  data: () => ({
    defaultSelectedPos: []
  }),
  methods: {
    scanTreeNode(val) {
      val.forEach((node, index) => {
        if (node.treeInfo.key === this.defaultSelectedKey) {
          this.defaultSelectedPos.push(index);
          this.selectedNode = [node, this.pos];
          node.treeInfo.selected = true;
        } else if (node.treeInfo.hasChild) {
          this.scanTreeNode(node.children);
        } else {
          node.treeInfo.selected = false;
        }
      });
    },
    onClickNode(e, node, position) {
      if (e instanceof Event) {
        e.stopPropagation();
      }
      if (this.selectedNode && this.selectedNode[0] && this.selectedNode[0].treeInfo) {
        if (node && node.treeInfo && !node.treeInfo.expanded) {
          this.onClickExpand(e, node);
        }
        this.selectedNode[0].treeInfo.selected = false;
      }
      if (node && node.treeInfo) {
        node.treeInfo.selected = true;
      }
      if (node === undefined && position === undefined) {
        this.selectedNode = undefined;
      } else {
        this.selectedNode = [node, position];
      }
      this.reRender();
    },
    emitClickAddButton(e, selectedNode, posArray) {
      if (e instanceof Event) {
        e.stopPropagation();
      }
      if (selectedNode === undefined) {
        selectedNode = Array.isArray(this.selectedNode) ? this.selectedNode[0] : {};
      }

      // $ver: v0.1.0
      // $arg: button click event, selected node, position array
      // 트리 상단의 Add 버튼 클릭 시, 현재 선택된 노드 정보를 파라미터로 이벤트를 발생시킵니다.
      // #Clicking the Add button at the top of the tree will trigger an event with the currently selected node information as a parameter.
      this.$emit('addButton', selectedNode, posArray, this.selectedNode);
    },
    emitClickDeleteButton(e, selectedNode, posArray) {
      if (e instanceof Event) {
        e.stopPropagation();
      }
      if (selectedNode === undefined) {
        selectedNode = Array.isArray(this.selectedNode) ? this.selectedNode[0] : {};
      }
      if (posArray === undefined) {
        posArray = Array.isArray(this.selectedNode) ? this.selectedNode[1] : [];
      }
      // $ver: v0.1.0
      // $arg: button click event, selected node, position array
      // labelAction 속성으로 보이는 삭제 버튼 클릭 시, 해당 노드 정보를 파라미터로 이벤트를 발생시킵니다.
      // #When the delete button shown in the labelAction property is clicked, an event is triggered using the node information as a parameter.
      this.$emit('deleteButton', selectedNode, posArray);
    },
    emitClickEditButton(e, selectedNode, posArray) {
      if (e instanceof Event) {
        e.stopPropagation();
      }
      if (selectedNode === undefined) {
        selectedNode = Array.isArray(this.selectedNode) ? this.selectedNode[0] : {};
      }
      if (posArray === undefined) {
        posArray = Array.isArray(this.selectedNode) ? this.selectedNode[1] : [];
      }
      // $ver: v0.1.0
      // $arg: button click event, selected node, position array
      // labelAction 속성으로 보이는 수정 버튼 클릭 시, 해당 노드 정보를 파라미터로 이벤트를 발생시킵니다.
      // #When the edit button clicked on the labelAction property is clicked, an event is triggered using the node information as a parameter.
      this.$emit('editButton', selectedNode, posArray);
    },
    emitSelectNode(e) {
      if (e instanceof Event) {
        e.stopPropagation();
      }
      let selectedNode = Array.isArray(this.selectedNode) ? this.selectedNode[0] : {};
      let posArray = Array.isArray(this.selectedNode) ? this.selectedNode[1] : [];

      // $ver: v0.1.0
      // $arg: button click event, selected node, position array
      // 선택된 노드가 변경될 경우, 해당 노드 정보를 파라미터로 이벤트를 발생시킵니다.
      // #When the selected node is changed, an event is triggered using the node information as a parameter.
      this.$emit('selectNode', selectedNode, posArray);
    }
  }
};
</script>
<style lang="scss" scoped></style>
